import { environment } from './../../../../environment/environment';
import { ApiResponse } from './../../models/response-api';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { BehaviorSubject, Observable, map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CandidatService extends CrudService<ApiResponse<any>, number> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }
  profileUpdated = new BehaviorSubject<any | null>(null);
  private _cachedProfile: any;
  private _cachedId: any;
  private searchResultsSubject = new BehaviorSubject<any[]>([]);
  searchResults$ = this.searchResultsSubject.asObservable();
 /* update profil Candidate  */
 updateCandidate(id:number, data: any): Observable<ApiResponse<any>> {
  return this._http.post<ApiResponse<any>>(this._base +`/api/User/editProfileCandidat?user_id=${id}`, data).pipe(
    tap(() => {
      this._cachedProfile = null;
      this._cachedId = null;
      this.profileUpdated.next(null);
    })
  );
}

getCatId(id:number,sort?:number){
  let sortData
  if(sort) sortData=`?sort=${sort}`
  return this._http.get<ApiResponse<any>>(this._base+`/api/Category/getCategoryDetails/${id}${sortData}`);
}
  // CandidateJobRequest/getSansPagination/{id}
  getListcandidatsanspagination(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/CandidateJobRequest/getSansPagination?client_id=${id}`
    );
  }
  addSkillsForCandidate(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(this._base +`/api/Skill/candidateAddSkill`, data);
  }
  addStarsForSkillCandidate(data: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(this._base + `/api/User/addSkills`, data);
  }
  
  /*delete all skills */
  deleteAllSkills(id: number) {
    return this._http.delete<ApiResponse<any>>(this._base + `/api/Skill/candidateDeleteAllSkills?id=${id}`);
  }
  /*delete on skill */
  
  deleteOnSkill(id: number,idSubCatgery:number) {
    return this._http.delete<ApiResponse<any>>(this._base + `/api/Skill/candidateDeleteOneSkill?id=${id}&sub_category_id=${idSubCatgery}`);
  }
  downloadFile(url: string) {
    return this._http.get(url, { responseType: 'blob' });
  }
  downloadFileZip(url: string): Observable<Blob> {
    return this._http.get(url, { responseType: 'blob' });
  }
  getPdfContent(pdfUrl: string): Observable<Blob> {
    return this._http.get(pdfUrl, { responseType: 'blob' });
  }

  deleteCandidat(job_request_id: any, user_id: any) {

    return this._http.delete<ApiResponse<any>>(
      this._base +
        `/api/CandidateJobRequest/delete?job_request_id=${job_request_id}&user_id=${user_id}`
    );
  }

  /*get candidate  by id */
  getUserById(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/User/userProfile?user_id=${id}`
    );
  }
  getUserByIdd(uuid:string){
    return this._http.get<ApiResponse<any>>(this._base+`/api/ConsultantEsn/getConsultantDetails/${uuid}`);
   }

  getUserByIdEmployee(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/ConsultantClientFinal/getSalarieByIdWithDetails?clientFinal_id=${id}`
    );
  }

  downloadPDF(url: string): Observable<Blob> {
    const options = { responseType: 'blob' as 'json' };
    return this._http
      .get<Blob>(url, options)
      .pipe(map((res: any) => new Blob([res], { type: 'application/pdf' })));
  }

  getskillscandidat(idcandidat: any): Observable<ApiResponse<any>> {
    return this._http
      .get<ApiResponse<any>>(
        `${this._base}/api/Skill/getSkillsByCandidate/${idcandidat}`
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  getSkills(): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/SubCategory/getListSubCateg`
    );
  }

  downloadPDFTest(url: string): Observable<Blob> {
    const options = { responseType: 'blob' as 'json' };
    return this._http
      .get<Blob>(url, options)
      .pipe(map((res: any) => new Blob([res], { type: 'application/pdf' })));
  }
  getListCategoriesCnadidat(data?:{per_page?:number,page?:number,sort?:number}){    
    return this._http.get<ApiResponse<any>>(this._base+`/api/Category/getListCategorywithDetails`);
  }
  /* get list candidats */
  getListCandidat(
    id: any,
    data: {
      per_page?: number;
      page?: number;
      sort?: number;
      sortAttribute?: string;
    }
  ) {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/CandidateJobRequest/getCandidatesByClientFinal/${id}
  ?per_page=${data?.per_page}&page=${data?.page}&sort=${data?.sort}&sortAttribute=${data.sortAttribute}`
    );
  }

  getListcandidature(data: {
    job_request_id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<
      ApiResponse<any>
    >(`${this._base}/api/CandidateJobRequest/getByJobRequest?job_request_id=${data.job_request_id}?
 per_page=${data?.per_page}&page=${data?.page}${sort}`);
  }
  getListcandidatureexterne(data: {
    id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}& sortAttribute=${data.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/CompanyApply/getCandidaturesByClientFinal/${data.id}?per_page=${data?.per_page}&page=${data?.page}${sort}`
    );
  }

  searchCandidatureexterne(
    id: number,
    data: any
  ): Observable<ApiResponse<any>> {
    let tabs = this.findDoubleQuotes(data.search);

    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    return this._http
      .post<ApiResponse<any>>(
        this._base +
          `/api/CompanyApply/searchInListCandidaturesByClientFinal/${id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  findDoubleQuotes(str: string): number[] {
    const indices: number[] = [];
    for (let i = 0; i < str.length; i++) {
      if (str[i] === '"') {
        indices.push(i);
      }
    }
    return indices;
  }
  searchCandidature(data: any) {

    return this._http.post<ApiResponse<any>>(
      this._base +
        `/api/CandidateJobRequest/searchInListCandidatesByClientFinal`,
      data
    );
  }
  getListcandidatureinterne(data: {
    id: number;
    per_page?: number;
    page?: number;
    sort?: number;
    sortAttribute?: string;
  }) {
    let sort = '';
    if (data?.sort)
      sort = `&sort=${data.sort}&sortAttribute=${data.sortAttribute}`;
    return this._http.get<ApiResponse<any>>(
      `${this._base}/api/CompanyApply/getListCandidatesByJobRequest/${data.id}?per_page=${data?.per_page}&page=${data?.page}${sort}`
    );
  }

  searchCandidatureinterne(
    id: number,
    data: any
  ): Observable<ApiResponse<any>> {
    let tabs = this.findDoubleQuotes(data.search);
    if (tabs.length <= 2) data.search = '"' + data.search + '"';
    return this._http
      .post<ApiResponse<any>>(
        this._base +
          `/api/CompanyApply/searchInListCandidatesByJobRequest/${id}`,
        data
      )
      .pipe(
        map((res: any) => {
          if (res) {
            return res;
          }
        })
      );
  }
  /* get candidate skills */
  getSkillsCandidate(id: number) {
    return this._http.get<ApiResponse<any>>(
      this._base + `/api/Skill/getSkillsByCandidate/${id}`
    );
  }
}
